import React from 'react';
import { Box, Heading, Text, VStack, Button, Image } from '@chakra-ui/react';
import { heroImage1, heroImage2, heroGradientShape } from '../../assets/figmaAssets';

export default function HeroSection() {
  return (
    <Box
      as="section"
      aria-label="Présentation de Résonance"
      position="relative"
      borderRadius="40px"
      overflow="hidden"
      h={{ base: "584px", md: "785px" }}
      style={{ backgroundImage: "linear-gradient(103.25deg, rgb(199, 229, 244) 3.39%, rgb(177, 240, 173) 30.70%, rgb(199, 229, 244) 98.53%)" }}
    >
      {/* Text Content */}
      <VStack
        position="relative"
        zIndex={2}
        align="start"
        gap={{ base: "16px", md: "20px" }}
        px={{ base: "26px", md: "70px" }}
        pt={{ base: "32px", md: "70px" }}
        maxW={{ base: "100%", md: "682px" }}
      >
        <Heading
          as="h1"
          fontSize={{ base: "24px", md: "50px" }}
          fontWeight="600"
          fontFamily="Inter, sans-serif"
          color="black"
          lineHeight={{ base: "1.25", md: "1.22" }}
          letterSpacing="0.1px"
        >
          Prendre la parole devient simple.
        </Heading>
        <Text
          fontSize={{ base: "16px", md: "22px" }}
          fontWeight="500"
          fontFamily="Inter, sans-serif"
          color="#585858"
          lineHeight="1.64"
          maxW={{ base: "287px", md: "509px" }}
          letterSpacing="0.1px"
        >
         Tous les jours à 19h, on se retrouve pour discuter autour d’un sujet commun, chacun à son rythme.
        </Text>
        <Button
          as="a"
          href="https://discord.gg/qJhmqbmcb2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Rejoins le Discord
        </Button>
      </VStack>

      {/* 
        Hero Images — Figma spec:
        Mask group: x=448, y=25, 721x765 (clips images on right side)
        Image 1: 729x877 at (324,172) → relative to mask: left=-124, top=147
        Image 2: 550x787 at (688,0) → relative to mask: left=240, top=-25
        Mobile mask: x=-12, y=206, 361x383
        Mobile Image 1: relative to mask: left=-62, top=74
        Mobile Image 2: relative to mask: left=120, top=-13
      */}
      <Box
        position="absolute"
        right={{ base: "0", md: "1px" }}
        top={{ base: "206px", md: "25px" }}
        w={{ base: "361px", md: "721px" }}
        h={{ base: "383px", md: "765px" }}
        pointerEvents="none"
        zIndex={1}
        overflow="hidden"
      >
        {/* Background image (larger, semi-transparent) */}
        <Image
          src={heroImage1}
          alt=""
          position="absolute"
          left={{ base: "-62px", md: "-124px" }}
          top={{ base: "74px", md: "147px" }}
          w={{ base: "365px", md: "729px" }}
          h={{ base: "439px", md: "877px" }}
          opacity={0.7}
          objectFit="cover"
        />
        {/* Foreground image (full opacity) */}
        <Image
          src={heroImage2}
          alt="Personne prenant la parole devant un groupe"
          position="absolute"
          left={{ base: "120px", md: "240px" }}
          top={{ base: "-13px", md: "-25px" }}
          w={{ base: "275px", md: "550px" }}
          h={{ base: "394px", md: "787px" }}
          objectFit="cover"
        />
        {/* 
          Gradient shape overlay (Vector 10)
          Figma: x=771.5, y=38.5, w=427.5, h=746.5
          Relative to mask (448, 25): left=323.5, top=13.5
          Mobile: scaled proportionally
        */}
        <Image
          src={heroGradientShape}
          alt=""
          position="absolute"
          left={{ base: "162px", md: "323.5px" }}
          top={{ base: "7px", md: "13.5px" }}
          w={{ base: "214px", md: "427.5px" }}
          h={{ base: "373px", md: "746.5px" }}
          pointerEvents="none"
        />
      </Box>
    </Box>
  );
}
